// import React, { useEffect, useRef, useState } from "react";
// import { Spin } from "antd";
// import { FileSearchOutlined, BarChartOutlined, RiseOutlined, CalendarOutlined, } from "@ant-design/icons";


// const ASSISTANT_MESSAGE =
//   "Hello, I am your Levridge assistant — I am currently under development and will be operational in 2026.";

// const SUGGESTIONS = [
//   {
//     text: "Find all my K-1 tax documents from 2024",
//     icon: FileSearchOutlined,
//   },
//   {
//     text: "What is my total exposure to venture capital?",
//     icon: BarChartOutlined,
//   },
//   {
//     text: "Show me my best performing funds this quarter",
//     icon: RiseOutlined,
//   },
//   {
//     text: "Which funds have upcoming capital calls?",
//     icon: CalendarOutlined,
//   },
// ];
// const EchoChat = () => {
//   const [input, setInput] = useState("");
//   const [messages, setMessages] = useState([
//     { role: "assistant", content: ASSISTANT_MESSAGE }
//   ]);

//   const endRef = useRef(null);

//   useEffect(() => {
//     endRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   const sendMessage = (text) => {
//     if (!text.trim()) return;
//     setMessages(prev => [
//       ...prev,
//       { role: "user", content: text },
//       { role: "assistant", content: ASSISTANT_MESSAGE }
//     ]);
//     setInput("");
//   };

//   return (
//     <Spin spinning={false}>
//       <div className="page">
//         {/* MAIN CARD */}
//         <div className="cardShell">
//           {/* HERO */}
//           <div className="center">
//             {/* <div className="logo">✦</div> */}
//             <div className="logo">
//               <img src="chatLogo.png" alt="logo" />
//             </div>
//             <div className="title">Insights AI Assistant</div>
//             <div className="subtitle">
//               Your intelligent companion for portfolio intelligence and document search
//             </div>

//             {/* <div className="grid">
//               {SUGGESTIONS.map((t, i) => (
//                 <div key={i} className="card" onClick={() => sendMessage(t)}>
//                   {t}
//                 </div>
//               ))}
//             </div> */}
//             {/* 
//             <div className="grid">
//               {SUGGESTIONS.map((item, i) => {
//                 const Icon = item.icon;

//                 return (
//                   <div
//                     key={i}
//                     className="card"
//                     onClick={() => sendMessage(item.text)}
//                   >
//                     <Icon className="icon" />
//                     <span>{item.text}</span>
//                   </div>
//                 );
//               })}
//             </div> */}

//             <div className="grid">
//               {SUGGESTIONS.map((item, i) => {
//                 const Icon = item.icon;

//                 return (
//                   <div
//                     key={i}
//                     className="card"
//                     onClick={() => sendMessage(item.text)}
//                   >
//                     <span className="iconWrap">
//                       <Icon />
//                     </span>
//                     <span className="text">{item.text}</span>
//                   </div>
//                 );
//               })}
//             </div>

//             <div className="comingSoon">
//               <strong>✦ Coming in 2026 <br /></strong>

//               <p className="description">
//                 We’re building advanced AI capabilities to transform how you interact with your private market investments.Try
//                 the preview below.
//               </p>
//             </div>
//           </div>

//           {/* CHAT */}
//           <div className="chat">
//             {messages.map((m, i) => (
//               <div key={i} className={`message ${m.role}`}>
//                 {m.content}
//               </div>
//             ))}
//             <div ref={endRef} />
//           </div>

//           {/* INPUT */}

//         </div>
//       </div>
//       <div className="inputWrapper">
//         <div className="inputPill">
//           <input
//             placeholder="Message Insights AI..."
//             value={input}
//             onChange={e => setInput(e.target.value)}
//             onKeyDown={e => e.key === "Enter" && sendMessage(input)}
//           />
//           <button
//             className="sendButton"
//             onClick={() => sendMessage(input)}
//             disabled={!input.trim()}
//           >
//             ↑
//           </button>
//         </div>
//       </div>
//     </Spin>
//   );
// }

// export default EchoChat;

import React, { useEffect, useRef, useState } from "react";
import { Spin, Row, Col, Input, Button } from "antd";
import { FileSearchOutlined, BarChartOutlined, RiseOutlined, CalendarOutlined, LineChartOutlined } from "@ant-design/icons";

const ASSISTANT_MESSAGE =
  "Hello, I am your Levridge assistant — I am currently under development and will be operational in 2026.";

const SUGGESTIONS = [
  { text: "Find all my K-1 tax documents from 2024", icon: FileSearchOutlined },
  { text: "What is my total exposure to venture capital?", icon: BarChartOutlined },
  { text: "Show me my best performing funds this quarter", icon: RiseOutlined },
  { text: "Which funds have upcoming capital calls?", icon: CalendarOutlined },
];


const EchoChat = () => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);

  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = (text) => {
    if (!text.trim()) return;
    setMessages((prev) => [
      ...prev,
      { role: "user", content: text },
      { role: "assistant", content: ASSISTANT_MESSAGE },
    ]);
    setInput("");
  };

  return (
    <Spin spinning={false}>
      <div className="pageInsight">
       
        <div className="cardShell echoChatMain">
          {/* HERO */}
          <div className="center">
            <div className="logo">
              <img src="chatLogo.png" alt="logo" />
            </div>

            <div className="title">Insights AI Assistant</div>
            <div style={{ color: "#F4F4F5B2", fontSize: "16px", marginBottom: "50px" }}>
              Your intelligent companion for portfolio intelligence and document search
            </div>

            {/* ✅ AntD Grid (responsive, CSS-safe) */}
            <Row className="grid" justify="center" gutter={[16, 16]}>
              {SUGGESTIONS.map((item, i) => {
                const Icon = item.icon;
                return (
                  <Col key={i} xs={24} sm={12} md={10} className="paddingRightRemoveColumn">
                    <div
                      className="card"
                      onClick={() => sendMessage(item.text)}
                    >
                      <span>
                        <Icon />
                      </span>
                      <span className="text">{item.text}</span>
                    </div>
                  </Col>
                );
              })}

              <Col xs={24} sm={22} md={20} className="commingSoonColPLR">
                <div className="comingSoonExact">
                  <div className="comingSoonHeader">
                    <span className="sparkle">✦</span>
                    <span className="comingSoonTitle">Coming in 2026</span>
                  </div>

                  <p className="comingSoonText">
                    We’re building advanced AI capabilities to transform how you interact
                    with your private market investments. Try the preview below.
                  </p>
                </div>
              </Col>

              <Col xs={24} sm={22} md={21}>
                <div className="chat">
                  {messages?.map((m) => (
                    <div
                      key={m.id || `${m.role}-${m.content}`}
                      className={`message ${m.role}`}
                    >
                      {m.content}
                    </div>
                  ))}
                  <div ref={endRef} />
                </div>
              </Col>
            </Row>
          </div>


          {/* CHAT */}
          {/* <div className="chat">
            {messages.map((m, i) => (
              <div key={i} className={`message ${m.role}`}>
                {m.content}
              </div>
            ))}
            <div ref={endRef} />
          </div> */}
        </div>
        
      </div>

      {/* INPUT */}
      {/* <div className="inputWrapper">
        <div className="inputPill">
          <Input
            placeholder="Message Insights AI..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onPressEnter={() => sendMessage(input)}
            bordered={false}
          />
          <Button
            shape="circle"
            className="sendBtn"
            onClick={() => sendMessage(input)}
            disabled={!input.trim()}
          >
            ↑
          </Button>
        </div>
      </div> */}
      <div className="inputWrapper">
        
        <div className="inputPill">
          {/* <input
            placeholder="Message Insights AI..."
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && sendMessage(input)}
          /> */}
          <textarea
            value={input}
            placeholder="Message Insights AI..."
            rows={1}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sendMessage(input);
              }
            }}
            ref={(el) => {
              if (el) {
                el.style.height = "auto";
                el.style.height = el.scrollHeight + "px";
              }
            }}
          />

          <button
            className="sendButton"
            onClick={() => sendMessage(input)}
            disabled={!input.trim()}
          >
            ↑
          </button>
        </div>
       
      </div>

    </Spin >
  );
};

export default EchoChat;

